/**
@license
Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
import { css } from 'lit';
export const ButtonSharedStyles = css `
  button {
    font-size: inherit;
    vertical-align: middle;
    background: transparent;
    border: none;
    cursor: pointer;
  }

  button:hover svg {
    fill: var(--app-primary-color);
  }

  button:active svg {
    fill: var(--app-secondary-color);
  }

  paper-button {
    font-size: inherit;
    vertical-align: middle;
    background: transparent;
    border: none;
    cursor: pointer;
  }

  paper-button:hover svg {
    fill: var(--app-primary-color);
  }

  paper-button:disabled svg {
    fill: var(--app-disabled-color);
  }

  paper-button[disabled] {
    color: var(--app-disabled-color);
  }

  paper-icon-button:hover {
    color: var(--app-primary-color);
  }
  
  paper-button:active svg {
    fill: var(--app-secondary-color);
  }
  .pos-button {
    font-weight: bold;
    color: var(--app-secondary-color);
    font-size: 1.5em;
    border: solid 1px var(--app-secondary-color);
    border-radius: 5px;
  }
  .pos-button[disabled] {
    color: var(--app-disabled-color);
    border: solid 1px var(--app-disabled-color);
  }

  .pos-button:disabled svg {
    fill: var(--app-disabled-color);
  }

  .pos-button:hover {
    color: var(--app-primary-color);
    border: solid 1px var(--app-primary-color);
    fill: var(--app-secondary-color);
  }
  .neg-button {
    color: var(--app-drawer-selected-color);
    font-weight: bold;
  }
  .neg-button:hover {
    color: var(--app-neg-text-color);
  }
  /*.bws-capsule-button {
    background-color: white;
    margin: .4em;
    padding: .3em .6em;
    border: .25px solid rgba(120, 144, 156,.2);
    border-radius: 20px;
    box-shadow: 2px 2px 2px darkgrey;
  }*/
  .bws-capsule-button {
    margin: .4em;
    padding: .6em .6em;
    border-radius: 15px;
    border: 1px solid lightgrey;
    font-size: 1.2em;
  }
  .bws-cap-sm {
    margin: .1em;
    padding: .1em .1em;
    border-radius: 10px;
    border: 1px solid lightgrey;
    font-size: .8em;
    text-align: center
  }
  .bws-lg-button {
    background-color: var(--app-primary-color);
    margin: 5px;
    color: white;
    font-weight: bold;
    font-size: 1.2em;
    padding: .5em;
    width: 95%;
  }

  .bws-red-button {
    background-color: red;
  }

  .bws-red-button[disabled] {
    background-color: lightsalmon;
    color: lightgrey;
  }

  .bws-lg-button[disabled] {
    background-color: lightgrey;
    color: black;
  }

  .bws-lg-button.red{
    background-color:fireBrick;
  }

  .bws-lg-button.orange{
    background-color:darkOrange;
  }

  .bws-lg-button:disabled {
    color: var(--app-drawer-selected-color);
    background-color: var(--app-secondary-color);
  }

  paper-icon-button.mini {
      width: 16px;
      height: 16px;
      padding:0px;
    }
  .popup-close-button {
    position: absolute;
    top: 8px;
    right: 8px;
    background: #f44336;
    color: white;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    min-width: 32px;
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
    padding: 0;
    z-index: 10001;
    border: 2px solid white;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`;
